import * as React from "react";
import PropTypes from "prop-types";

import MuiDialogContent from "@mui/material/DialogContent";
import { RectSkeleton } from "ui/Skeleton";

function DialogContent(props) {
  const { children, preLoading, preLoadingHeight, contentClassName } = props;
  const hasChildren = !!children;

  if (!hasChildren) {
    return null;
  }

  const renderContent = () => {
    if (preLoading) {
      return <RectSkeleton height={preLoadingHeight} />;
    }
    return children;
  };

  return (
    <MuiDialogContent
      sx={{ padding: "24px 24px 0 24px", wordBreak: "break-all" }}
      className={contentClassName}
    >
      {renderContent()}
    </MuiDialogContent>
  );
}

export const DialogContentPropTypes = {
  children: PropTypes.any,
  preLoading: PropTypes.bool,
  preLoadingHeight: PropTypes.string,
  contentClassName: PropTypes.string,
};

DialogContent.propTypes = DialogContentPropTypes;

export default DialogContent;
